<template>
  <v-card>
    <p>Tteste</p>
  </v-card>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    mountAlerts(classType, msg) {
      this.alerts.items.push({ classType, msg });
    },
  },
};
</script>
